(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/svs-suspension/svs-suspension.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/svs-suspension/svs-suspension.js');
'use strict';

const {
  useDispatch
} = ReactRedux;
const {
  useHistory
} = ReactRouterDOM;
const {
  PageMenu
} = svs.accountservices.pageMenu;
const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  ActiveSuspensions,
  SetSuspension,
  HistorySuspensions,
  FaqSuspension
} = svs.spelpaus.pages.svsSuspension.components;
const {
  getActiveSuspensionsAsync,
  getHistorySuspensionsAsync
} = svs.spelpaus.pages.svsSuspension.SvsSuspensionService;
const {
  setActiveSuspensions,
  setHistorySuspensions
} = svs.spelpaus.store.suspension.actions;
const {
  ROUTE
} = svs.spelpaus.constants;

const SvsSuspension = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  React.useEffect(() => {
    const getData = async () => {
      const active = await getActiveSuspensionsAsync();
      dispatch(setActiveSuspensions(active));
      const history = await getHistorySuspensionsAsync();
      dispatch(setHistorySuspensions(history));
    };
    getData();
  }, [dispatch]);
  return React.createElement(React.Fragment, null, React.createElement(PageMenu, {
    backFunc: () => history.push(ROUTE.home),
    backText: "Spelpaus start",
    title: ""
  }), React.createElement("div", {
    className: "align-center padding-1 line-height-150"
  }, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, {
    className: "u-text-left",
    xs: 12,
    sm: {
      col: 8,
      offset: 2
    },
    md: {
      col: 6,
      offset: 3
    }
  }, React.createElement(ActiveSuspensions, null))), React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    xs: 12
  }, React.createElement("h2", {
    className: "align-center margin-top-3 h2"
  }, "Spelpaus Svenska Spel"))), React.createElement(GridRow, null, React.createElement(GridCol, {
    sm: {
      col: 8,
      offset: 2
    },
    xs: {
      col: 12,
      offset: 0
    }
  }, React.createElement(GridRow, null, React.createElement(GridCol, {
    xs: 12,
    sm: {
      col: 12,
      offset: 0
    },
    md: {
      col: 6,
      offset: 0
    }
  }, React.createElement("div", {
    className: "align-center"
  }, React.createElement(SetSuspension, null)), React.createElement("div", {
    className: "align-center margin-top-2"
  }, React.createElement(HistorySuspensions, null))), React.createElement(GridCol, {
    xs: 12,
    sm: {
      col: 12,
      offset: 0
    },
    md: {
      col: 6,
      offset: 0
    }
  }, React.createElement("div", {
    className: "align-center"
  }, React.createElement(FaqSuspension, null)))))))));
};
svs.spelpaus.pages.svsSuspension.SvsSuspension = SvsSuspension;

 })(window);